import { useContext } from 'react';
import { PaymentsContext } from '../contexts/payments-context';

export const usePayments = () => {
  const context = useContext(PaymentsContext);
  if (!context) {
    throw new Error(
      'usePayments must be used within a PaymentsContext Provider',
    );
  }
  return context;
};
